import { render } from "./TransactionsPanel.vue?vue&type=template&id=08220e46&scoped=true&lang=pug"
import script from "./TransactionsPanel.vue?vue&type=script&lang=js"
export * from "./TransactionsPanel.vue?vue&type=script&lang=js"

import "./TransactionsPanel.scss?vue&type=style&index=0&id=08220e46&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08220e46"]])

export default __exports__